import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import { Loader } from "@/components/ui-bits";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Packages from "@/pages/Packages";
import Wallets from "@/pages/Wallets";
import Referrals from "@/pages/Referrals";
import Team from "@/pages/Team";
import MagicCards from "@/pages/MagicCards";
import SilverCard from "@/pages/SilverCard";
import Withdraw from "@/pages/Withdraw";
import Transactions from "@/pages/Transactions";
import Account from "@/pages/Account";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminApprovals from "@/pages/admin/AdminApprovals";
import AdminWithdrawals from "@/pages/admin/AdminWithdrawals";
import AdminUserTransactions from "@/pages/admin/AdminUserTransactions";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminMagicCards from "@/pages/admin/AdminMagicCards";
import AdminSilverCard from "@/pages/admin/AdminSilverCard";
import AdminReports from "@/pages/admin/AdminReports";
import AdminSettings from "@/pages/admin/AdminSettings";

function Protected({ children, role }) {
  const { user, checking } = useAuth();
  if (checking || user === undefined) return <div className="app-bg min-h-screen"><Loader /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/app" replace />;
  if (role === "user" && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}

function UserRoute({ children }) {
  return (
    <Protected role="user">
      <AppShell>{children}</AppShell>
    </Protected>
  );
}

function AdminRoute({ children }) {
  return (
    <Protected role="admin">
      <AppShell admin>{children}</AppShell>
    </Protected>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" theme="dark" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/app" element={<UserRoute><Dashboard /></UserRoute>} />
          <Route path="/app/packages" element={<UserRoute><Packages /></UserRoute>} />
          <Route path="/app/wallets" element={<UserRoute><Wallets /></UserRoute>} />
          <Route path="/app/referrals" element={<UserRoute><Referrals /></UserRoute>} />
          <Route path="/app/team" element={<UserRoute><Team /></UserRoute>} />
          <Route path="/app/cards" element={<UserRoute><MagicCards /></UserRoute>} />
          <Route path="/app/silver" element={<UserRoute><SilverCard /></UserRoute>} />
          <Route path="/app/withdraw" element={<UserRoute><Withdraw /></UserRoute>} />
          <Route path="/app/transactions" element={<UserRoute><Transactions /></UserRoute>} />
          <Route path="/app/account" element={<UserRoute><Account /></UserRoute>} />

          <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/approvals" element={<AdminRoute><AdminApprovals /></AdminRoute>} />
          <Route path="/admin/withdrawals" element={<AdminRoute><AdminWithdrawals /></AdminRoute>} />
          <Route path="/admin/user-transactions" element={<AdminRoute><AdminUserTransactions /></AdminRoute>} />
          <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
          <Route path="/admin/magic-cards" element={<AdminRoute><AdminMagicCards /></AdminRoute>} />
          <Route path="/admin/silver-cards" element={<AdminRoute><AdminSilverCard /></AdminRoute>} />
          <Route path="/admin/reports" element={<AdminRoute><AdminReports /></AdminRoute>} />
          <Route path="/admin/settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
